import CreateCourseSchedulePage from './CreateCourseSchedulePage';
import { CreateCourseSchedulePageProps, CreateCourseSchedulePageValueProps } from './types';

export type { CreateCourseSchedulePageProps, CreateCourseSchedulePageValueProps };
export default CreateCourseSchedulePage;
